import { __extends } from "tslib";
import { PersistedPriorityQueue } from '../../lib/priority-queue/persisted';
import { CoreEventQueue } from '@customerio/cdp-analytics-core';
var EventQueue = /** @class */ (function (_super) {
    __extends(EventQueue, _super);
    function EventQueue(priorityQueue) {
        return _super.call(this, priorityQueue !== null && priorityQueue !== void 0 ? priorityQueue : new PersistedPriorityQueue(4, 'event-queue')) || this;
    }
    return EventQueue;
}(CoreEventQueue));
export { EventQueue };
//# sourceMappingURL=event-queue.js.map